'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var orange7 = exports.orange7 = '#AB3C21';
var orange6 = exports.orange6 = '#C94727'; // aka darkOrange

var orange5 = exports.orange5 = '#DD5832';
var orange4 = exports.orange4 = '#F1693C';
var orange3 = exports.orange3 = '#FF793F';
var orange2 = exports.orange2 = '#FF9357';
var orange1 = exports.orange1 = '#FFA370';
var orange = {
  7: orange7,
  6: orange6,
  5: orange5,
  4: orange4,
  3: orange3,
  2: orange2,
  1: orange1
};
exports.default = orange;